import { useEffect, useState } from "react";

export const useStaticJobs = (keyword = "Software Engineer", country = "us", page = 1) => {
  const [jobs, setJobs] = useState([]);
  const [totalJobs, setTotalJobs] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchJobs = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const formData = new FormData();
        formData.append("country", country);
        formData.append("page", page);
        formData.append("what", keyword); // ✅ static keyword

        const res = await fetch("/jobs/search", {
          method: "POST",
          body: formData,
        });

        if (!res.ok) {
          const errData = await res.json();
          throw new Error(errData.detail || "Failed to fetch jobs.");
        }

        const data = await res.json();
        setJobs(data.results || []);
        setTotalJobs(data.count || 0);
      } catch (err) {
        setError(err.message);
        setJobs([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchJobs();
  }, [keyword, country, page]);

  return { jobs, totalJobs, isLoading, error };
};
